import type { BrandId } from './types';
import { getActiveBrandId } from './index';
import { brand } from '@/config/brand';
import techRaw from './brand-tech.json' assert { type: 'json' };

export interface BrandTechnical {
  canonicalDomain?: string;
  ga4MeasurementId?: string;
  gtmId?: string;
  metaPixelId?: string;
  googleAdsConversionId?: string;
  googleAdsPurchaseLabel?: string;
  trustpilotBusinessUnitId?: string;
  trustpilotReviewDomain?: string;
  stripeStatementDescriptor?: string;
}

function clean(v: unknown): string | undefined {
  return typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined;
}

export function getBrandTechnical(id: BrandId = getActiveBrandId()): BrandTechnical {
  // techRaw includes a non-brand `_comment` maintenance string (see brand-tech.json),
  // so cast through unknown — lookups are keyed by BrandId and never hit `_comment`.
  const raw = (techRaw as unknown as Record<string, Record<string, string>>)[id] ?? {};
  return {
    canonicalDomain: clean(raw.canonicalDomain),
    ga4MeasurementId: clean(raw.ga4MeasurementId),
    gtmId: clean(raw.gtmId),
    metaPixelId: clean(raw.metaPixelId),
    googleAdsConversionId: clean(raw.googleAdsConversionId),
    googleAdsPurchaseLabel: clean(raw.googleAdsPurchaseLabel),
    trustpilotBusinessUnitId: clean(raw.trustpilotBusinessUnitId),
    trustpilotReviewDomain: clean(raw.trustpilotReviewDomain),
    stripeStatementDescriptor: clean(raw.stripeStatementDescriptor),
  };
}

export function getCanonicalBase(): string {
  const t = getBrandTechnical();
  const base = t.canonicalDomain ?? brand.website.url;
  return base.replace(/\/$/, '');
}
